import { Chip, Grid, Icon } from '@mui/material';

import clsx from 'clsx';

import SemesterIcon from './SemesterIcon';

interface Props {
  object: { name: string; semester?: string; icon?: string };
  selected: boolean;
  onClick: Function;
  type: 'author' | 'recipient';
  disabled?: boolean;
}

interface SemesterProps {
  object: { name: string; semester: string; icon?: string };
  selected: boolean;
  onClick: Function;
  type: 'semester';
  disabled?: boolean;
}

type CombinedProps = Props | SemesterProps;

export function RoleCard(props: CombinedProps) {
  const handleClick = () => {
    props.onClick();
  };
  const icon =
    props.type === 'semester' ? (
      <SemesterIcon type={parseInt(props.object.semester, 10)} active={props.selected} />
    ) : (
      <Icon
        className={clsx(props.object.icon, 'rolecard__icon')}
        style={{ color: props.selected ? 'orange' : 'grey', width: 'auto' }}
      />
    );
  const label = props.object.name.replace('IDM_UA_', '').replace('IDM_', '');
  return (
    <Grid item xs="auto" className="rolecard">
      <Chip
        className="rolecard__body"
        variant="outlined"
        icon={icon}
        onClick={handleClick}
        disabled={props.disabled}
        label={label}
        color={props.selected ? 'primary' : 'default'}
      />
    </Grid>
  );
}
